import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=920e1a20&scoped=true&"
import script from "./CartButton.vue?vue&type=script&lang=js&"
export * from "./CartButton.vue?vue&type=script&lang=js&"
import style0 from "./CartButton.vue?vue&type=style&index=0&id=920e1a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920e1a20",
  null
  
)

export default component.exports